import React from 'react';
import PropTypes from 'prop-types';


const line = () => (
  <svg width="1px" height="61px" viewBox="0 0 1 61" version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink">
    <g id="Welcome" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
      <g id="Desktop-HD" transform="translate(-678.000000, -7865.000000)" stroke="#7ED7B4">
        <path d="M678.5,7865.5 L678.5,7925.5" id="Line-6"></path>
      </g>
    </g>
  </svg>
);

const Quote = ({ quote }) => (
  <div className="template__quote tac">
    <div className="template__quote-line">{line()}</div>
    <div className="template__quote-wrapper tac">{quote}</div>
    <div className="template__quote-line">{line()}</div>
  </div>
);

Quote.propTypes = {
  quote: PropTypes.string.isRequired,
};

export default Quote;

export const query = graphql`
  fragment QuoteFragment on PrismicCaseStudyBodyQuote {
    slice_type
    primary {
      quote
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/CaseStudy/Quote/Quote.js